export const MAGIC_LINK_ERROR_FLAG = 'magic-link-expired'
export const MAGIC_LINK_ERROR_MESSAGE =
    'This magic link is invalid or has expired. Please login again.'
